import { Base } from 'layouts'
import { ChargeDataList } from 'components'

import * as S from './styled'

export function ChargeData() {
  return (
    <Base>
      <S.GridContainer container>
        <ChargeDataList />
      </S.GridContainer>
    </Base>
  )
}
